import { createStore, createLogger} from 'vuex'
import auth from './modules/auth.module'
import request from './modules/request.module'

// const plugins = []
//
// if (process.env.NODE_ENV === 'development') {
//   plugins.push(createLogger())
// }

export default createStore({
 // plugins,
  state() {
    return {
      route: "/",
      message: null,
      burger: false
    }
  },
  mutations: {
    setMessage(state, message) {
      state.message = message
    },
    clearMessage(state) {
      state.message = null
    },
    toggleBurger(state) {
      state.burger = !state.burger
    }
  },
  actions: {
    setMessage({commit}, message) {
      commit(`setMessage`, message)
      setTimeout(() => {
        commit(`clearMessage`)
      }, 4000)
    }
  },
  modules: {
    auth, request
  }
})



